module.exports = __webpack_public_path__ + "static/media/IEADA.ef4999c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/IEADA.jpg
// module id = 1753
// module chunks = 1